export type TabIcon = "atlas" | "labels" | "calculator" | "overview" | "default";

/** Which family icon a browser tab shows, so the tools tell apart at a glance. */
export function tabIconFor(pathname: string): TabIcon {
  const first = pathname.split("/")[1] ?? "";
  if (["", "atlas", "atlas-v4", "mobile", "archive", "blends", "workshop", "whiskey"].includes(first)) return "atlas";
  if (first === "labels" || first === "label" || pathname.startsWith("/admin/labels")) return "labels";
  if (first === "calculator" || first === "safety-calculator") return "calculator";
  if (first === "overview" || first === "safety-overview") return "overview";
  return "default";
}

export function tabIconFiles(icon: TabIcon): { svg: string; png: string } {
  const base = icon === "default" ? "/favicon" : `/favicon-${icon}`;
  return { svg: `${base}.svg`, png: `${base}-32.png` };
}
